<div class="ec-container">
  <div class="ec-sidebar">
    <div class="ec-sidebar-header">
      <div class="ec-logo-container">
        <div class="ec-logo">E</div>
        <h1 class="ec-title">Ethan</h1>
      </div>
      <button class="ec-new-chat-btn" (click)="onCreateNewClick()">
        <mat-icon>add</mat-icon>
        <span>New chat</span>
      </button>
    </div>

    <div class="ec-search-container">
      <div class="ec-search-wrapper">
        <mat-icon class="ec-search-icon">search</mat-icon>
        <input [formControl]="searchControl" class="ec-search-input" placeholder="Search conversations..." />
      </div>
    </div>

    <div *ngIf="createNewInputVisible" class="ec-new-chat-input-container">
      <input
        #newChatInput
        [formControl]="newChatControl"
        (keydown.esc)="hideInput()"
        (keydown.enter)="createNewChat()"
        class="ec-new-chat-input"
        placeholder="Name your conversation..."
      />
      <div class="ec-new-chat-actions">
        <button mat-icon-button (click)="createNewChat()" class="ec-action-btn">
          <mat-icon>check</mat-icon>
        </button>
        <button mat-icon-button (click)="hideInput()" class="ec-action-btn">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="ec-chats-container">
      <div class="ec-chats-label">Recent conversations</div>

      <div *ngIf="ethanChats.length <= 0 && !chatsLoading && !createNewInputVisible" class="ec-empty-chats">
        <mat-icon class="ec-empty-icon">chat</mat-icon>
        <p class="ec-empty-text">No conversations yet</p>
        <p class="ec-empty-subtext">Start a new chat to begin</p>
      </div>

      <div class="ec-chats-list">
        <div *ngFor="let chat of ethanChats" class="ec-chat-item" [class.ec-active-chat]="selectedChat?.id === chat.id">
          <div class="ec-chat-item-content" (click)="toggleScreen(chat.id)">
            <mat-icon class="ec-chat-icon">chat</mat-icon>
            <div class="ec-chat-name">{{ chat.name }}</div>
          </div>
          <button
            mat-icon-button
            class="ec-chat-menu-btn"
            [matMenuTriggerFor]="chatMenu"
            (click)="$event.stopPropagation()"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #chatMenu="matMenu">
            <button mat-menu-item (click)="onDelete(chat.id)">
              <mat-icon>delete</mat-icon>
              <span>Delete conversation</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
  </div>

  <div class="ec-main">
    <div *ngIf="!selectedChat" class="ec-welcome">
      <div class="ec-welcome-content">
        <div class="ec-welcome-logo">E</div>
        <h2 class="ec-welcome-title">Welcome to Ethan</h2>
        <button class="ec-welcome-btn" (click)="onCreateNewClick()">Start a new conversation</button>
      </div>
    </div>

    <div *ngIf="selectedChat" class="ec-chat-view">
      <div class="ec-chat-header">
        <h2 class="ec-chat-title">{{ selectedChat.name }}</h2>
        <button mat-icon-button class="ec-exit-btn" (click)="navigateBack()" title="Exit full screen">
          <mat-icon>fullscreen_exit</mat-icon>
        </button>
      </div>

      <div class="ec-messages-container">
        <div #chatContent class="ec-messages" (scroll)="onScroll($event)">
          <div *ngIf="ethanStateQuestions[selectedChat?.id].loading" class="ec-loading">
            <div class="ec-loading-animation">
              Loading<span class="ec-dots"><span>.</span><span>.</span><span>.</span></span>
            </div>
          </div>

          <div
            *ngIf="ethanQuestions.length <= 0 && !this.ethanStateQuestions[selectedChat?.id].loading"
            class="ec-empty-messages"
          >
            <div class="ec-empty-logo">E</div>
            <h3 class="ec-empty-title">How can I help you today?</h3>
            <p class="ec-empty-subtitle">Ask me anything about your project</p>
          </div>

          <div class="ec-message-list">
            <ng-container *ngFor="let ethanQuestion of ethanQuestions; let i = index; let last = last">
              <div
                *ngIf="
                  (i === 0 || (ethanQuestion.updated_at | date: 'MMMM dd, yyyy')) !==
                  (ethanQuestions[i - 1]?.updated_at | date: 'MMMM dd, yyyy')
                "
                class="ec-date-separator"
              >
                <div class="ec-date">{{ ethanQuestion.updated_at | date: 'MMMM dd, yyyy' }}</div>
              </div>

              <div class="ec-user-message">
                <div class="ec-user-avatar">
                  <img *ngIf="currentUser?.avatar_url" [src]="currentUser?.avatar_url" alt="User avatar" />
                  <div *ngIf="!currentUser?.avatar_url" class="ec-avatar-placeholder">
                    {{ currentUser?.full_name?.charAt(0) }}
                  </div>
                </div>
                <div class="ec-user-content">
                  <div class="ec-message-text">{{ ethanQuestion.question }}</div>
                  <div *ngIf="ethanQuestion.file_url" class="ec-file-attachment">
                    <mat-icon class="ec-file-icon">description</mat-icon>
                    <a [href]="ethanQuestion.file_url" target="_blank" class="ec-file-link">
                      {{ ethanQuestion.file_name }}
                    </a>
                  </div>
                </div>
              </div>

              <div class="ec-ethan-message">
                <div class="ec-ethan-avatar">E</div>
                <div class="ec-ethan-content">
                  <ng-container *ngIf="last && isLoading && !ethanQuestion.answer">
                    <div class="ec-thinking-animation">
                      Thinking<span class="ec-dots"><span>.</span><span>.</span><span>.</span></span>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="ethanQuestion.answer">
                    <div class="ec-markdown">
                      <markdown
                        *ngIf="ethanQuestion.answer"
                        [data]="formatMarkdownWithCitations(ethanQuestion.answer)"
                      ></markdown>
                      <span *ngIf="!ethanQuestion.answer" class="ec-error-message">Sorry, unable to fetch answer</span>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="ec-input-container">
        <div class="flex p-1 dark:bg-transparent">
          <div class="input-area w-full">
            <form [formGroup]="ethanForm" class="px-6" (ngSubmit)="$event.preventDefault()">
              <div
                class="form-control-wrapper form-control-with-filter-inline-button has-icon flex flex-col w-full p-0.5 ethan-input-gradient mb-2"
              >
                <div
                  *ngIf="selectedFile && !isLoading"
                  class="selected-file-wrapper flex items-center gap-2 px-3 py-1 mb-1"
                >
                  <mat-icon class="text-white text-sm">description</mat-icon>
                  <span class="text-white text-sm flex-1 truncate">{{ selectedFile.name }}</span>
                  <mat-spinner *ngIf="fileUploading" [diameter]="16" color="accent"></mat-spinner>
                  <button mat-icon-button class="remove-file-btn" (click)="removeSelectedFile()" *ngIf="!fileUploading">
                    <mat-icon class="text-white text-sm">close</mat-icon>
                  </button>
                </div>

                <div class="flex w-full ethan-input-wrapper items-center">
                  <button
                    mat-icon-button
                    class="ethan-file-upload-btn"
                    (click)="fileInput.click()"
                    [disabled]="isLoading"
                    title="Attach file"
                  >
                    <mat-icon style="color: white">attach_file</mat-icon>
                  </button>
                  <input #fileInput type="file" hidden (change)="onFileSelected($event)" />

                  <input
                    type="text"
                    autosize
                    placeholder="Send a message"
                    [formControlName]="'question'"
                    rows="1"
                    class="form-control w-full ethan-input text-white p-1"
                    (keydown.enter)="$event.preventDefault(); askQuestionToEthan()"
                    [disabled]="isLoading || fileUploading"
                  />

                  <button
                    *ngIf="!isLoading"
                    mat-icon-button
                    matSuffix
                    (click)="askQuestionToEthan()"
                    type="button"
                    title="Submit"
                    [disabled]="isLoading || !ethanForm.value.question || fileUploading"
                  >
                    <mat-icon style="color: white" [svgIcon]="'send'"></mat-icon>
                  </button>
                  <button
                    *ngIf="isLoading"
                    mat-icon-button
                    matSuffix
                    (click)="stopReading()"
                    type="button"
                    title="Stop"
                  >
                    <mat-icon [svgIcon]="'stop'"></mat-icon>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
